import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthContext';
import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import { db } from '../firebase';
import { collection, getDocs, query, where, doc, getDoc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { format, addDays, isAfter, differenceInDays, parseISO } from 'date-fns';
import { Timestamp } from 'firebase/firestore';
import Grid from '@mui/material/Grid2';
import {
  Container,
  Paper,
  Avatar,
  Button,
  Stack,
  Typography,
  Chip,
  Box,
  CircularProgress,
  Fade,
  LinearProgress,
  TextField,
  Modal,
  IconButton,
  Divider,
} from '@mui/material';
import { styled } from '@mui/system';
import { Link } from 'react-router-dom';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import CastForEducationIcon from '@mui/icons-material/CastForEducation';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CalculateIcon from '@mui/icons-material/Calculate';
import FunctionsIcon from '@mui/icons-material/Functions';
import NumbersIcon from '@mui/icons-material/Numbers';
import PercentIcon from '@mui/icons-material/Percent';
import PlusOneIcon from '@mui/icons-material/PlusOne';
import ExposureIcon from '@mui/icons-material/Exposure';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import StraightenIcon from '@mui/icons-material/Straighten';
import TimelineIcon from '@mui/icons-material/Timeline';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import BarChartIcon from '@mui/icons-material/BarChart';
import PieChartIcon from '@mui/icons-material/PieChart';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import TableChartIcon from '@mui/icons-material/TableChart';
import OneKIcon from '@mui/icons-material/OneK';
import TwoKIcon from '@mui/icons-material/TwoK';
import ThreeKIcon from '@mui/icons-material/ThreeK';
import FourKIcon from '@mui/icons-material/FourK';
import FiveKIcon from '@mui/icons-material/FiveK';
import SixKIcon from '@mui/icons-material/SixK';
import SevenKIcon from '@mui/icons-material/SevenK';
import EightKIcon from '@mui/icons-material/EightK';
import NineKIcon from '@mui/icons-material/NineK';
import StarIcon from '@mui/icons-material/Star';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import FolderIcon from '@mui/icons-material/Folder';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import MathGemLogoMain from '../assets/MathGemLogoMain.png';
import Confetti from 'react-confetti';

// Modern color palette
const colors = {
  primary: '#2ecc71',
  secondary: '#34495e',
  background: '#f5f7fa',
  accent: '#3498db',
  gradientStart: 'rgba(62,180,137,1)',
  gradientEnd: 'rgba(144,238,144,1)',
};

// Styled components
const ModernCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: '16px',
  background: 'white',
  border: '1px solid rgba(0, 0, 0, 0.05)',
  boxShadow: '0 6px 18px rgba(0, 0, 0, 0.06)',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    transform: 'translateY(-6px)',
    boxShadow: '0 12px 24px rgba(0, 0, 0, 0.1)',
  },
}));

const ChipStyled = styled(Chip)(({ theme }) => ({
  borderRadius: '24px',
  padding: theme.spacing(0.75, 1.5),
  fontWeight: '600',
  fontSize: '0.9rem',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: colors.accent,
    color: 'white',
  },
}));

const AnimatedButton = styled(Button)(({ theme }) => ({
  borderRadius: '12px',
  textTransform: 'none',
  fontWeight: '600',
  padding: theme.spacing(1.5, 3),
  transition: 'all 0.3s ease, transform 0.2s ease',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  '&:hover': {
    backgroundColor: colors.accent,
    color: 'white',
    transform: 'scale(1.05)',
    boxShadow: '0 6px 18px rgba(0, 0, 0, 0.15)',
    '& svg': {
      transform: 'translateX(6px)',
    },
  },
}));

const ModalContent = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '95%', sm: 400 },
  maxWidth: '400px',
  background: 'rgba(255, 255, 255, 0.85)',
  backdropFilter: 'blur(12px)',
  borderRadius: '24px',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
  padding: theme.spacing(4),
  textAlign: 'center',
  animation: 'fadeInScale 0.3s ease-out',
  '@keyframes fadeInScale': {
    '0%': { opacity: 0, transform: 'translate(-50%, -50%) scale(0.8)' },
    '100%': { opacity: 1, transform: 'translate(-50%, -50%) scale(1)' },
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
  },
}));

const WelcomeModalContent = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '95%', sm: 600 },
  maxWidth: '600px',
  background: 'rgba(255, 255, 255, 0.95)',
  backdropFilter: 'blur(10px)',
  borderRadius: '24px',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
  padding: theme.spacing(4),
  textAlign: 'center',
  animation: 'fadeInScale 0.3s ease-out',
  '@keyframes fadeInScale': {
    '0%': { opacity: 0, transform: 'translate(-50%, -50%) scale(0.8)' },
    '100%': { opacity: 1, transform: 'translate(-50%, -50%) scale(1)' },
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
  },
}));

const LearningGoalsModalContent = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90vw',
  maxWidth: '600px',
  background: 'rgba(255, 255, 255, 0.95)',
  backdropFilter: 'blur(10px)',
  borderRadius: '24px',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
  padding: theme.spacing(4),
  textAlign: 'center',
  maxHeight: '90vh',
  overflowY: 'auto',
  animation: 'fadeInScale 0.3s ease-out',
  '@keyframes fadeInScale': {
    '0%': { opacity: 0, transform: 'translate(-50%, -50%) scale(0.8)' },
    '100%': { opacity: 1, transform: 'translate(-50%, -50%) scale(1)' },
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
    '& .MuiTypography-h5': { fontSize: '1.5rem' },
    '& .MuiTypography-body1': { fontSize: '0.9rem' },
    '& .MuiTextField-root': {
      '& .MuiInputBase-input': { fontSize: '0.9rem' },
      '& .MuiInputLabel-root': { fontSize: '0.9rem' },
    },
    '& .MuiButton-root': { fontSize: '0.9rem', padding: theme.spacing(1, 2) },
  },
}));

const Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [subjects, setSubjects] = useState([]);
  const [schoolLevels, setSchoolLevels] = useState([]);
  const [topics, setTopics] = useState([]);
  const [allTopics, setAllTopics] = useState([]);
  const [pastPapers, setPastPapers] = useState([]);
  const [allPastPapers, setAllPastPapers] = useState([]);
  const [revisionPapers, setRevisionPapers] = useState([]);
  const [allRevisionPapers, setAllRevisionPapers] = useState([]);
  const [topicResources, setTopicResources] = useState({});
  const [viewedResources, setViewedResources] = useState([]);
  const [recommendedTopics, setRecommendedTopics] = useState([]);
  const [selectedChip, setSelectedChip] = useState('All Topics');
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedSchoolLevel, setSelectedSchoolLevel] = useState(null);
  const [selectedPastPaperCategory, setSelectedPastPaperCategory] = useState(null);
  const [selectedRevisionPaperCategory, setSelectedRevisionPaperCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [trialExpired, setTrialExpired] = useState(false);
  const [trialDaysRemaining, setTrialDaysRemaining] = useState(null);
  const [subscriptionExpired, setSubscriptionExpired] = useState(false);
  const [subscriptionDaysRemaining, setSubscriptionDaysRemaining] = useState(null);
  const [error, setError] = useState(null);
  const [openWelcomeModal, setOpenWelcomeModal] = useState(false);
  const [openLearningGoalsModal, setOpenLearningGoalsModal] = useState(false);
  const [openPremiumModal, setOpenPremiumModal] = useState(false);
  const [openTrialExpiredModal, setOpenTrialExpiredModal] = useState(false);
  const [openSubscriptionExpiredModal, setOpenSubscriptionExpiredModal] = useState(false);
  const [learningGoal, setLearningGoal] = useState('');
  const [currentTarget, setCurrentTarget] = useState('');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showConfetti, setShowConfetti] = useState(false);

  const iconMap = {
    Calculate: <CalculateIcon />,
    Functions: <FunctionsIcon />,
    Numbers: <NumbersIcon />,
    Percent: <PercentIcon />,
    PlusOne: <PlusOneIcon />,
    Exposure: <ExposureIcon />,
    SquareFoot: <SquareFootIcon />,
    Straighten: <StraightenIcon />,
    Timeline: <TimelineIcon />,
    ShowChart: <ShowChartIcon />,
    BarChart: <BarChartIcon />,
    PieChart: <PieChartIcon />,
    ScatterPlot: <ScatterPlotIcon />,
    TableChart: <TableChartIcon />,
    OneK: <OneKIcon />,
    TwoK: <TwoKIcon />,
    ThreeK: <ThreeKIcon />,
    FourK: <FourKIcon />,
    FiveK: <FiveKIcon />,
    SixK: <SixKIcon />,
    SevenK: <SevenKIcon />,
    EightK: <EightKIcon />,
    NineK: <NineKIcon />,
  };

  const slides = [
    {
      title: 'Welcome to MathGem!',
      description: 'Explore a wide range of math topics and past papers tailored to your level.',
      icon: <MenuBookIcon sx={{ fontSize: 60, color: colors.primary }} />,
    },
    {
      title: 'Learn at Your Pace',
      description: 'Access free and premium resources with progress tracking.',
      icon: <CastForEducationIcon sx={{ fontSize: 60, color: colors.primary }} />,
    },
    {
      title: 'Join Our Community',
      description: 'Upgrade to premium for exclusive content and more!',
      icon: <LocationCityIcon sx={{ fontSize: 60, color: colors.primary }} />,
    },
  ];

  // Convert date to JavaScript Date
  const convertToDate = (dateInput) => {
    if (!dateInput) return null;
    if (dateInput instanceof Timestamp) return dateInput.toDate();
    if (dateInput instanceof Date) return dateInput;
    if (typeof dateInput === 'string') {
      try {
        const parsedDate = parseISO(dateInput);
        if (isNaN(parsedDate)) return null;
        return parsedDate;
      } catch {
        return null;
      }
    }
    return null;
  };

  // Check trial status and calculate remaining days
  const checkTrialStatus = async () => {
    if (!user || !['trial', 'pending payment'].includes(user.status)) {
      console.log('checkTrialStatus: Not a trial or pending payment user', { userStatus: user?.status });
      return { isExpired: false, daysRemaining: null };
    }
    try {
      const userDocRef = doc(db, `users/${user.uid}`);
      const userDoc = await getDoc(userDocRef);
      if (!userDoc.exists()) {
        console.log('checkTrialStatus: User document not found');
        return { isExpired: false, daysRemaining: null };
      }
      const { trialStartDate, trialEndDate, createdAt } = userDoc.data();
      console.log('checkTrialStatus: trialStartDate, trialEndDate, createdAt', { trialStartDate, trialEndDate, createdAt });

      // Use createdAt as fallback for trialStartDate if trialStartDate is missing
      const trialStart = convertToDate(trialStartDate) || convertToDate(createdAt);
      const trialEnd = convertToDate(trialEndDate);

      if (!trialEnd) {
        console.log('checkTrialStatus: Missing or invalid trialEndDate');
        return { isExpired: false, daysRemaining: null };
      }

      const currentDate = new Date();
      const isExpired = isAfter(currentDate, trialEnd);
      const daysRemaining = isExpired ? 0 : Math.max(0, differenceInDays(trialEnd, currentDate));
      console.log('checkTrialStatus: Result', { isExpired, daysRemaining, trialStart, trialEnd });
      return { isExpired, daysRemaining };
    } catch (err) {
      console.error('Error checking trial status:', err);
      setError('Failed to verify trial status.');
      return { isExpired: false, daysRemaining: null };
    }
  };

  // Check subscription status and calculate remaining days
  const checkSubscriptionStatus = async () => {
    if (!user || user.status !== 'premium') {
      console.log('checkSubscriptionStatus: Not a premium user', { userStatus: user?.status });
      return { isExpired: false, daysRemaining: null };
    }
    try {
      const userDocRef = doc(db, `users/${user.uid}`);
      const userDoc = await getDoc(userDocRef);
      if (!userDoc.exists()) {
        console.log('checkSubscriptionStatus: User document not found');
        return { isExpired: false, daysRemaining: null };
      }
      const { subscriptionStart, subscriptionEnd } = userDoc.data();
      console.log('checkSubscriptionStatus: subscriptionStart, subscriptionEnd', { subscriptionStart, subscriptionEnd });

      const subscriptionEndDate = convertToDate(subscriptionEnd);

      if (!subscriptionEndDate) {
        console.log('checkSubscriptionStatus: Missing or invalid subscriptionEnd');
        return { isExpired: false, daysRemaining: null };
      }

      const currentDate = new Date();
      const isExpired = isAfter(currentDate, subscriptionEndDate);
      const daysRemaining = isExpired ? 0 : Math.max(0, differenceInDays(subscriptionEndDate, currentDate));
      console.log('checkSubscriptionStatus: Result', { isExpired, daysRemaining, subscriptionEndDate });
      return { isExpired, daysRemaining };
    } catch (err) {
      console.error('Error checking subscription status:', err);
      setError('Failed to verify subscription status.');
      return { isExpired: false, daysRemaining: null };
    }
  };

  // Check user status and modals
  const initializeUserStatus = async () => {
    if (!user) {
      console.log('initializeUserStatus: No user');
      return;
    }
    try {
      const userDocRef = doc(db, `users/${user.uid}`);
      const userDoc = await getDoc(userDocRef);
      const userData = userDoc.exists() ? userDoc.data() : {};
      console.log('initializeUserStatus: User data', userData);

      // Check trial status
      const { isExpired: isTrialExpired, daysRemaining: trialDays } = await checkTrialStatus();
      setTrialExpired(isTrialExpired);
      setTrialDaysRemaining(trialDays);
      setOpenTrialExpiredModal(isTrialExpired);

      // Check subscription status for premium users
      const { isExpired: isSubscriptionExpired, daysRemaining: subscriptionDays } = await checkSubscriptionStatus();
      setSubscriptionExpired(isSubscriptionExpired);
      setSubscriptionDaysRemaining(subscriptionDays);
      setOpenSubscriptionExpiredModal(isSubscriptionExpired);

      if (!isTrialExpired && !isSubscriptionExpired) {
        const isFirstSignIn = !userData.hasSeenWelcomeModal;
        const isEmailVerified = user.emailVerified && !userData.emailVerifiedModalShown;
        if (isFirstSignIn || isEmailVerified) {
          console.log('initializeUserStatus: Opening welcome modal', { isFirstSignIn, isEmailVerified });
          setOpenWelcomeModal(true);
          await setDoc(
            userDocRef,
            {
              hasSeenWelcomeModal: true,
              emailVerifiedModalShown: user.emailVerified ? true : userData.emailVerifiedModalShown || false,
            },
            { merge: true }
          );
        }

        if (!userData.hasSetLearningGoals && !isFirstSignIn && !isEmailVerified) {
          console.log('initializeUserStatus: Opening learning goals modal');
          setOpenLearningGoalsModal(true);
        }

        if (userData.status === 'premium' && !userData.hasSeenPremiumConfetti) {
          console.log('initializeUserStatus: Showing premium confetti');
          setShowConfetti(true);
          await setDoc(userDocRef, { hasSeenPremiumConfetti: true }, { merge: true });
        }

        if ((userData.status === 'premium' || userData.status === 'trial' || userData.status === 'pending payment') && userData.learningGoal) {
          const goalKeywords = userData.learningGoal.toLowerCase().split(/\s+/);
          const targetTopics = allTopics.filter((topic) =>
            goalKeywords.some(
              (keyword) =>
                topic.name.toLowerCase().includes(keyword) ||
                topic.description?.toLowerCase().includes(keyword)
            )
          );
          setRecommendedTopics(targetTopics.slice(0, 3));
        }
      }
    } catch (err) {
      console.error('Error initializing user status:', err);
      setError('Failed to load user data.');
    }
  };

  // Fetch subjects
  const fetchSubjects = async () => {
    try {
      const subjectsSnap = await getDocs(collection(db, 'subjects'));
      setSubjects(
        subjectsSnap.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .sort((a, b) => a.name.localeCompare(b.name))
      );
    } catch (err) {
      console.error('Error fetching subjects:', err);
      setError('Failed to load subjects.');
    }
  };

  // Fetch school levels
  const fetchSchoolLevels = async () => {
    try {
      const schoolLevelsSnap = await getDocs(collection(db, 'schoolLevels'));
      setSchoolLevels(schoolLevelsSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    } catch (err) {
      console.error('Error fetching school levels:', err);
      setError('Failed to load school levels.');
    }
  };

  // Fetch topics
  const fetchTopics = async () => {
    try {
      const topicsSnap = await getDocs(collection(db, 'topics'));
      const topicsData = topicsSnap.docs
        .map((doc) => ({ id: doc.id, ...doc.data(), accessStatus: doc.data().accessStatus || 'free' }))
        .sort((a, b) => a.name.localeCompare(b.name));
      setTopics(topicsData);
      setAllTopics(topicsData);
      return topicsData;
    } catch (err) {
      console.error('Error fetching topics:', err);
      setError('Failed to load topics.');
      return [];
    }
  };

  // Fetch past papers
  const fetchPastPapers = async () => {
    try {
      const pastPapersSnap = await getDocs(collection(db, 'pastPapers'));
      const pastPapersData = pastPapersSnap.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
          url: doc.data().url || 'N/A',
          solutionsUrl: doc.data().solutionsUrl || 'N/A',
          accessStatus: doc.data().accessStatus || 'free',
          category: doc.data().category || 'Uncategorized',
        }))
        .sort((a, b) => a.title.localeCompare(b.title));
      setPastPapers(pastPapersData);
      setAllPastPapers(pastPapersData);
      return pastPapersData;
    } catch (err) {
      console.error('Error fetching past papers:', err);
      setError('Failed to load past papers.');
      return [];
    }
  };

  // Fetch revision papers
  const fetchRevisionPapers = async () => {
    try {
      const revisionPapersSnap = await getDocs(collection(db, 'revisionPapers'));
      const revisionPapersData = revisionPapersSnap.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
          quizUrl: doc.data().quizUrl || doc.data().url || 'N/A',
          leaderboardUrl: doc.data().leaderboardUrl || doc.data().solutionsUrl || 'N/A',
          accessStatus: doc.data().accessStatus || 'free',
          category: doc.data().category || 'Uncategorized',
        }))
        .sort((a, b) => a.title.localeCompare(b.title));
      setRevisionPapers(revisionPapersData);
      setAllRevisionPapers(revisionPapersData);
      return revisionPapersData;
    } catch (err) {
      console.error('Error fetching revision papers:', err);
      setError('Failed to load revision papers.');
      return [];
    }
  };

  // Fetch topic resources
  const fetchTopicResources = async (topicsData) => {
    const resourcesMap = {};
    try {
      await Promise.all(
        topicsData.map(async (topic) => {
          const resourcesSnap = await getDocs(collection(db, `topics/${topic.id}/resources`));
          resourcesMap[topic.id] = resourcesSnap.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
        })
      );
      setTopicResources(resourcesMap);
    } catch (err) {
      console.error('Error fetching topic resources:', err);
      setError('Failed to load topic resources.');
    }
  };

  // Fetch viewed resources
  const fetchViewedResources = async () => {
    if (!user) return;
    try {
      const viewedSnap = await getDocs(collection(db, `users/${user.uid}/viewedResources`));
      setViewedResources(viewedSnap.docs.map((doc) => doc.data().resourceId));
    } catch (err) {
      console.error('Error fetching viewed resources:', err);
      setError('Failed to load viewed resources.');
    }
  };

  // Fetch all data on mount
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const topicsData = await fetchTopics();
      const pastPapersData = await fetchPastPapers();
      await Promise.all([
        fetchSubjects(),
        fetchSchoolLevels(),
        fetchTopicResources(topicsData),
        fetchViewedResources(),
        fetchRevisionPapers(),
        initializeUserStatus(),
      ]);
      setLoading(false);
    };
    fetchData();
  }, [user]);

  // Handle search
  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    if (selectedChip === 'All Topics') {
      const filteredTopics = allTopics.filter(
        (topic) =>
          topic.name.toLowerCase().includes(query) ||
          topic.description?.toLowerCase().includes(query)
      );
      setTopics(filteredTopics);
    } else if (selectedChip === 'Past Papers') {
      const filteredPastPapers = allPastPapers.filter(
        (paper) =>
          paper.category === selectedPastPaperCategory &&
          (paper.title.toLowerCase().includes(query) ||
            paper.description?.toLowerCase().includes(query))
      );
      setPastPapers(filteredPastPapers);
    } else if (selectedChip === 'Revision Hub') {
      const filteredRevisionPapers = allRevisionPapers.filter(
        (paper) =>
          paper.category === selectedRevisionPaperCategory &&
          (paper.title.toLowerCase().includes(query) ||
            paper.description?.toLowerCase().includes(query))
      );
      setRevisionPapers(filteredRevisionPapers);
    }
  };

  // Handle past paper category selection
  const handleViewPastPaperCategory = (category) => {
    setSelectedPastPaperCategory(category);
    setSearchQuery('');
    setPastPapers(allPastPapers.filter((paper) => paper.category === category));
  };

  // Get past paper categories with counts
  const getPastPaperCategories = () => {
    const counts = {};
    allPastPapers.forEach((paper) => {
      counts[paper.category] = (counts[paper.category] || 0) + 1;
    });
    return Object.keys(counts)
      .sort((a, b) => a.localeCompare(b))
      .map((name) => ({ name, count: counts[name] }));
  };

  const handleViewPastPaperSolution = (paper) => {
    if (!['premium'].includes(user?.status) || subscriptionExpired) {
      handlePremiumModalOpen();
    } else if (paper.solutionsUrl && paper.solutionsUrl !== 'N/A') {
      window.open(paper.solutionsUrl, '_blank', 'noopener,noreferrer');
    } else {
      setError('No solutions URL available for this past paper.');
    }
  };

  // Handle revision paper category selection
  const handleViewRevisionPaperCategory = (category) => {
    setSelectedRevisionPaperCategory(category);
    setSearchQuery('');
    setRevisionPapers(allRevisionPapers.filter((paper) => paper.category === category));
  };

  // Get revision paper categories with counts
  const getRevisionPaperCategories = () => {
    const counts = {};
    allRevisionPapers.forEach((paper) => {
      counts[paper.category] = (counts[paper.category] || 0) + 1;
    });
    return Object.keys(counts)
      .sort((a, b) => a.localeCompare(b))
      .map((name) => ({ name, count: counts[name] }));
  };

  const handleViewRevisionLeaderboard = (paper) => {
    if (!['premium'].includes(user?.status) || subscriptionExpired) {
      handlePremiumModalOpen();
    } else if (paper.leaderboardUrl && paper.leaderboardUrl !== 'N/A') {
      window.open(paper.leaderboardUrl, '_blank', 'noopener,noreferrer');
    } else {
      setError('No leaderboard URL available for this revision paper.');
    }
  };

  // Handle chip selection
  const handleChipClick = async (label) => {
    setSelectedChip(label);
    setSelectedSubject(null);
    setSelectedSchoolLevel(null);
    setSelectedPastPaperCategory(null);
    setSelectedRevisionPaperCategory(null);
    setSearchQuery('');
    if (label === 'All Topics') {
      await fetchTopics();
    } else if (label === 'Past Papers') {
      await fetchPastPapers();
    } else if (label === 'Revision Hub') {
      await fetchRevisionPapers();
    }
  };

  // Handle subject selection
  const handleViewSubject = async (subjectId) => {
    setSelectedSubject(subjectId);
    setSelectedSchoolLevel(null);
    setSearchQuery('');
    setLoading(true);
    try {
      const topicsQuery = query(collection(db, 'topics'), where('subjectId', '==', subjectId));
      const querySnapshot = await getDocs(topicsQuery);
      const topicsData = querySnapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data(), accessStatus: doc.data().accessStatus || 'free' }))
        .sort((a, b) => a.name.localeCompare(b.name));
      setTopics(topicsData);
      await fetchTopicResources(topicsData);
    } catch (err) {
      console.error('Error fetching subject topics:', err);
      setError('Failed to load topics for subject.');
    } finally {
      setLoading(false);
    }
  };

  // Handle school level selection
  const handleViewSchoolLevelTopics = async (schoolLevelId) => {
    setSelectedSchoolLevel(schoolLevelId);
    setSelectedSubject(null);
    setSearchQuery('');
    setLoading(true);
    try {
      const topicsQuery = query(collection(db, 'topics'), where('schoolLevelId', '==', schoolLevelId));
      const querySnapshot = await getDocs(topicsQuery);
      const topicsData = querySnapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data(), accessStatus: doc.data().accessStatus || 'free' }))
        .sort((a, b) => a.name.localeCompare(b.name));
      setTopics(topicsData);
      await fetchTopicResources(topicsData);
    } catch (err) {
      console.error('Error fetching school level topics:', err);
      setError('Failed to load topics for school level.');
    } finally {
      setLoading(false);
    }
  };

  // Calculate topic progress
  const getTopicProgress = (topicId) => {
    const resources = topicResources[topicId] || [];
    const totalResources = resources.length;
    const viewedCount = resources.filter((r) => viewedResources.includes(r.id)).length;
    const percentage = totalResources > 0 ? Math.round((viewedCount / totalResources) * 100) : 0;
    return { viewedCount, totalResources, percentage };
  };

  // Calculate subject progress
  const getSubjectProgress = (subjectId) => {
    const subjectTopics = allTopics.filter((t) => t.subjectId === subjectId);
    let totalResources = 0;
    let viewedCount = 0;
    subjectTopics.forEach((topic) => {
      const topicProgress = getTopicProgress(topic.id);
      totalResources += topicProgress.totalResources;
      viewedCount += topicProgress.viewedCount;
    });
    const percentage = totalResources > 0 ? Math.round((viewedCount / totalResources) * 100) : 0;
    return { viewedCount, totalResources, percentage };
  };

  // Calculate school level progress
  const getSchoolLevelProgress = (schoolLevelId) => {
    const levelTopics = allTopics.filter((t) => t.schoolLevelId === schoolLevelId);
    let totalResources = 0;
    let viewedCount = 0;
    levelTopics.forEach((topic) => {
      const topicProgress = getTopicProgress(topic.id);
      totalResources += topicProgress.totalResources;
      viewedCount += topicProgress.viewedCount;
    });
    const percentage = totalResources > 0 ? Math.round((viewedCount / totalResources) * 100) : 0;
    return { viewedCount, totalResources, percentage };
  };

  // Modal handlers
  const handlePremiumModalOpen = () => setOpenPremiumModal(true);
  const handlePremiumModalClose = () => setOpenPremiumModal(false);
  const handleWelcomeModalClose = () => {
    setOpenWelcomeModal(false);
    initializeUserStatus();
  };
  const handleNextSlide = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      handleWelcomeModalClose();
    }
  };
  const handlePrevSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };
  const handleLearningGoalsClose = async () => {
    setOpenLearningGoalsModal(false);
    if (['trial', 'pending payment'].includes(user?.status)) {
      const { isExpired, daysRemaining } = await checkTrialStatus();
      setTrialExpired(isExpired);
      setTrialDaysRemaining(daysRemaining);
      setOpenTrialExpiredModal(isExpired);
      console.log('handleLearningGoalsClose: Updated trial status', { isExpired, daysRemaining });
    } else if (user?.status === 'premium') {
      const { isExpired, daysRemaining } = await checkSubscriptionStatus();
      setSubscriptionExpired(isExpired);
      setSubscriptionDaysRemaining(daysRemaining);
      setOpenSubscriptionExpiredModal(isExpired);
      console.log('handleLearningGoalsClose: Updated subscription status', { isExpired, daysRemaining });
    }
  };
  const handleLearningGoalsSubmit = async () => {
    if (!learningGoal || !currentTarget) {
      alert('Please fill in both learning goal and current target.');
      return;
    }
    try {
      const userDocRef = doc(db, `users/${user.uid}`);
      await setDoc(
        userDocRef,
        { learningGoal, currentTarget, hasSetLearningGoals: true },
        { merge: true }
      );
      setOpenLearningGoalsModal(false);
      if (['premium', 'trial', 'pending payment'].includes(user?.status)) {
        const goalKeywords = learningGoal.toLowerCase().split(/\s+/);
        const targetTopics = allTopics.filter((topic) =>
          goalKeywords.some(
            (keyword) =>
              topic.name.toLowerCase().includes(keyword) ||
              topic.description?.toLowerCase().includes(keyword)
          )
        );
        setRecommendedTopics(targetTopics.slice(0, 3));
      }
      if (['trial', 'pending payment'].includes(user?.status)) {
        const { isExpired, daysRemaining } = await checkTrialStatus();
        setTrialExpired(isExpired);
        setTrialDaysRemaining(daysRemaining);
        setOpenTrialExpiredModal(isExpired);
        console.log('handleLearningGoalsSubmit: Updated trial status', { isExpired, daysRemaining });
      } else if (user?.status === 'premium') {
        const { isExpired, daysRemaining } = await checkSubscriptionStatus();
        setSubscriptionExpired(isExpired);
        setSubscriptionDaysRemaining(daysRemaining);
        setOpenSubscriptionExpiredModal(isExpired);
        console.log('handleLearningGoalsSubmit: Updated subscription status', { isExpired, daysRemaining });
      }
    } catch (err) {
      console.error('Error saving learning goals:', err);
      setError('Failed to save learning goals.');
    }
  };

  const handleTrialExpiredModalClose = async () => {
    setOpenTrialExpiredModal(false);
    try {
      await signOut(auth);
      navigate('/login');
    } catch (err) {
      console.error('Error logging out:', err);
      setError('Failed to log out. Please try again.');
    }
  };

  const handleSubscriptionExpiredModalClose = async () => {
    setOpenSubscriptionExpiredModal(false);
    try {
      await signOut(auth);
      navigate('/login');
    } catch (err) {
      console.error('Error logging out:', err);
      setError('Failed to log out. Please try again.');
    }
  };

  // Handle past paper click
  const handleViewPastPaper = (paper) => {
    if (paper.accessStatus === 'premium' && (!['premium', 'trial', 'pending payment'].includes(user?.status) || subscriptionExpired)) {
      handlePremiumModalOpen();
    } else if (paper.url && paper.url !== 'N/A') {
      window.open(paper.url, '_blank', 'noopener,noreferrer');
    } else {
      setError('No download URL available for this past paper.');
    }
  };

  // Handle revision paper click
  const handleStartRevisionQuiz = (paper) => {
    if (paper.accessStatus === 'premium' && (!['premium', 'trial', 'pending payment'].includes(user?.status) || subscriptionExpired)) {
      handlePremiumModalOpen();
    } else if (paper.quizUrl && paper.quizUrl !== 'N/A') {
      window.open(paper.quizUrl, '_blank', 'noopener,noreferrer');
    } else {
      setError('No quiz URL available for this revision paper.');
    }
  };

  if (loading) {
    return (
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: colors.background,
        }}
      >
        <img src={MathGemLogoMain} width={350} alt="Math Gem Logo" />
        <Fade in={true} timeout={600}>
          <LinearProgress
            sx={{ color: colors.primary, mb: 2, mt: 5, width: '50%' }}
            size={60}
            thickness={4}
          />
        </Fade>
        <Typography variant="h6" sx={{ color: colors.secondary }}>
          Loading your dashboard...
        </Typography>
      </Container>
    );
  }

  const isPremiumUser = user?.status === 'premium' && !subscriptionExpired;
  const starColor = isPremiumUser ? '#95a5a6' : '#f1c40f';
  const trialProgress = trialDaysRemaining !== null ? ((7 - trialDaysRemaining) / 7) * 100 : 0;
  const subscriptionProgress = subscriptionDaysRemaining !== null ? 
    ((differenceInDays(convertToDate("2025-11-08T07:49:56.351Z"), convertToDate("2025-10-09T07:49:56.351Z")) - subscriptionDaysRemaining) / 
     differenceInDays(convertToDate("2025-11-08T07:49:56.351Z"), convertToDate("2025-10-09T07:49:56.351Z"))) * 100 : 0;

  return (
    <div style={{ background: colors.background, position: 'relative' }}>
      {showConfetti && (
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          recycle={false}
          numberOfPieces={200}
          confettiSource={{ x: window.innerWidth / 2, y: window.innerHeight / 2, w: 0, h: 0 }}
          colors={[colors.primary, colors.accent, colors.secondary]}
        />
      )}

      <Container sx={{ py: 8, minHeight: '100vh', mt: 5 }}>
        <Modal
          open={openTrialExpiredModal}
          onClose={handleTrialExpiredModalClose}
          sx={{ '& .MuiBackdrop-root': { backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' } }}
        >
          <ModalContent>
            <IconButton
              onClick={handleTrialExpiredModalClose}
              sx={{ position: 'absolute', top: 12, right: 12, color: colors.secondary }}
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h5" sx={{ fontWeight: '700', color: colors.secondary, mb: 2 }}>
              Trial Expired
            </Typography>
            <Typography variant="body1" sx={{ color: colors.secondary, mb: 3, opacity: 0.85, fontSize: '1.1rem' }}>
              Your trial period has ended. Upgrade to a premium account to continue accessing all materials.
            </Typography>
            <AnimatedButton
              variant="contained"
              onClick={() => navigate('/pricing')}
              sx={{
                background: `linear-gradient(45deg, ${colors.primary}, ${colors.accent})`,
                color: 'white',
                fontSize: '1rem',
                padding: '12px 32px',
                mb: 2,
              }}
            >
              Upgrade to Premium
            </AnimatedButton>
            <AnimatedButton
              variant="outlined"
              onClick={handleTrialExpiredModalClose}
              sx={{
                color: colors.secondary,
                borderColor: colors.secondary,
                fontSize: '1rem',
                padding: '12px 32px',
              }}
            >
              Close
            </AnimatedButton>
          </ModalContent>
        </Modal>

        <Modal
          open={openSubscriptionExpiredModal}
          onClose={handleSubscriptionExpiredModalClose}
          sx={{ '& .MuiBackdrop-root': { backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' } }}
        >
          <ModalContent>
            <IconButton
              onClick={handleSubscriptionExpiredModalClose}
              sx={{ position: 'absolute', top: 12, right: 12, color: colors.secondary }}
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h5" sx={{ fontWeight: '700', color: colors.secondary, mb: 2 }}>
              Subscription Expired
            </Typography>
            <Typography variant="body1" sx={{ color: colors.secondary, mb: 3, opacity: 0.85, fontSize: '1.1rem' }}>
              Your premium subscription has ended. Renew your subscription to continue accessing premium materials.
            </Typography>
            <AnimatedButton
              variant="contained"
              onClick={() => navigate('/pricing')}
              sx={{
                background: `linear-gradient(45deg, ${colors.primary}, ${colors.accent})`,
                color: 'white',
                fontSize: '1rem',
                padding: '12px 32px',
                mb: 2,
              }}
            >
              Renew Subscription
            </AnimatedButton>
            <AnimatedButton
              variant="outlined"
              onClick={handleSubscriptionExpiredModalClose}
              sx={{
                color: colors.secondary,
                borderColor: colors.secondary,
                fontSize: '1rem',
                padding: '12px 32px',
              }}
            >
              Close
            </AnimatedButton>
          </ModalContent>
        </Modal>

        <Modal
          open={openWelcomeModal}
          onClose={handleWelcomeModalClose}
          sx={{ '& .MuiBackdrop-root': { backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' } }}
        >
          <WelcomeModalContent>
            <IconButton
              onClick={handleWelcomeModalClose}
              sx={{ position: 'absolute', top: 12, right: 12, color: colors.secondary }}
            >
              <CloseIcon />
            </IconButton>
            <Box sx={{ mb: 4 }}>
              {slides[currentSlide].icon}
              <Typography variant="h5" sx={{ fontWeight: '700', color: colors.secondary, mt: 2, mb: 2 }}>
                {slides[currentSlide].title}
              </Typography>
              <Typography variant="body1" sx={{ color: colors.secondary, opacity: 0.85, fontSize: '1.1rem' }}>
                {slides[currentSlide].description}
              </Typography>
            </Box>
            <Stack direction="row" spacing={2} justifyContent="center" sx={{ mb: 2 }}>
              {slides.map((_, index) => (
                <Box
                  key={index}
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    backgroundColor: index === currentSlide ? colors.primary : 'rgba(0, 0, 0, 0.2)',
                  }}
                />
              ))}
            </Stack>
            <Stack direction="row" spacing={2} justifyContent="space-between">
              <IconButton
                onClick={handlePrevSlide}
                disabled={currentSlide === 0}
                sx={{ color: currentSlide === 0 ? 'rgba(0, 0, 0, 0.3)' : colors.secondary }}
              >
                <ArrowBackIosIcon />
              </IconButton>
              <AnimatedButton
                variant="contained"
                onClick={handleNextSlide}
                sx={{
                  background: `linear-gradient(45deg, ${colors.primary}, ${colors.accent})`,
                  color: 'white',
                  fontSize: '1rem',
                  padding: '10px 24px',
                }}
              >
                {currentSlide === slides.length - 1 ? 'Get Started' : 'Next'}
              </AnimatedButton>
              <IconButton
                onClick={handleNextSlide}
                disabled={currentSlide === slides.length - 1}
                sx={{ color: currentSlide === slides.length - 1 ? 'rgba(0, 0, 0, 0.3)' : colors.secondary }}
              >
                <ArrowForwardIosIcon />
              </IconButton>
            </Stack>
          </WelcomeModalContent>
        </Modal>

        <Modal
          open={openLearningGoalsModal}
          onClose={handleLearningGoalsClose}
          sx={{ '& .MuiBackdrop-root': { backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' } }}
        >
          <LearningGoalsModalContent>
            <IconButton
              onClick={handleLearningGoalsClose}
              sx={{ position: 'absolute', top: 12, right: 12, color: colors.secondary }}
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h5" sx={{ fontWeight: '700', color: colors.secondary, mb: 2 }}>
              Welcome to Maths Gem Seychelles!
            </Typography>
            <Typography variant="body1" sx={{ color: colors.secondary, mb: 3, opacity: 0.85 }}>
              Let’s set your learning goals to personalize your experience.
            </Typography>
            <TextField
              label="What is your learning goal?"
              value={learningGoal}
              onChange={(e) => setLearningGoal(e.target.value)}
              fullWidth
              margin="normal"
              placeholder="E.g., I want to improve my algebra skills"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                  '& fieldset': { borderColor: colors.primary },
                  '&:hover fieldset': { borderColor: colors.accent },
                  '&.Mui-focused fieldset': { borderColor: colors.accent },
                },
                '& .MuiInputLabel-root': {
                  color: colors.secondary,
                  '&.Mui-focused': { color: colors.accent },
                },
              }}
            />
            <TextField
              label="What are your current targets?"
              value={currentTarget}
              onChange={(e) => setCurrentTarget(e.target.value)}
              fullWidth
              margin="normal"
              placeholder="E.g., Score 90% in my next math exam"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                  '& fieldset': { borderColor: colors.primary },
                  '&:hover fieldset': { borderColor: colors.accent },
                  '&.Mui-focused fieldset': { borderColor: colors.accent },
                },
                '& .MuiInputLabel-root': {
                  color: colors.secondary,
                  '&.Mui-focused': { color: colors.accent },
                },
              }}
            />
            <AnimatedButton
              variant="contained"
              onClick={handleLearningGoalsSubmit}
              sx={{
                background: `linear-gradient(45deg, ${colors.primary}, ${colors.accent})`,
                color: 'white',
                mt: 2,
              }}
            >
              Save Goals
            </AnimatedButton>
          </LearningGoalsModalContent>
        </Modal>

        <Modal
          open={openPremiumModal}
          onClose={handlePremiumModalClose}
          sx={{ '& .MuiBackdrop-root': { backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' } }}
        >
          <ModalContent>
            <IconButton
              onClick={handlePremiumModalClose}
              sx={{ position: 'absolute', top: 12, right: 12, color: colors.secondary }}
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h5" sx={{ fontWeight: '700', color: colors.secondary, mb: 2 }}>
              Premium Content
            </Typography>
            <Typography variant="body1" sx={{ color: colors.secondary, mb: 3, opacity: 0.85, fontSize: '1.1rem' }}>
              Only Premium Accounts can access this material. Upgrade now to unlock exclusive resources!
            </Typography>
            <AnimatedButton
              variant="contained"
              onClick={() => navigate('/pricing')}
              sx={{
                background: `linear-gradient(45deg, ${colors.primary}, ${colors.accent})`,
                color: 'white',
                fontSize: '1rem',
                padding: '12px 32px',
              }}
            >
              Upgrade to Premium
            </AnimatedButton>
          </ModalContent>
        </Modal>

        {error && (
          <Typography color="error" sx={{ mb: 4, textAlign: 'center' }}>
            {error}
          </Typography>
        )}

        {!openTrialExpiredModal && !openSubscriptionExpiredModal && (
          <ModernCard
            sx={{
              mb: 5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              p: 4,
              background: `linear-gradient(159deg, ${colors.gradientStart} 0%, ${colors.gradientEnd} 100%)`,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Avatar sx={{ bgcolor: 'white', color: colors.primary, mr: 3, width: 56, height: 56 }}>
                {user.fullName?.charAt(0).toUpperCase()}
              </Avatar>
              <Box>
                <Typography variant="h5" sx={{ fontWeight: '700', color: 'white' }}>
                  Welcome, {user.fullName || 'User'}!
                </Typography>
                <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
                  {user.email}
                </Typography>
              </Box>
            </Box>
            {['trial', 'pending payment'].includes(user?.status) && trialDaysRemaining !== null && !trialExpired && (
              <Box sx={{ textAlign: 'center' }}>
                <Box sx={{ position: 'relative', display: 'inline-flex', mb: 2 }}>
                  <CircularProgress
                    variant="determinate"
                    value={trialProgress}
                    size={80}
                    thickness={5}
                    sx={{ color: 'white' }}
                  />
                  <Box
                    sx={{
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      position: 'absolute',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Typography
                      variant="caption"
                      component="div"
                      sx={{ color: 'white', fontWeight: '600', fontSize: '1rem' }}
                    >
                      {`${trialDaysRemaining} day${trialDaysRemaining !== 1 ? 's' : ''} left`}
                    </Typography>
                  </Box>
                </Box>
                <AnimatedButton
                  variant="contained"
                  onClick={() => navigate('/pricing')}
                  sx={{
                    background: colors.accent,
                    color: 'white',
                    fontSize: '0.9rem',
                    padding: '8px 16px',
                  }}
                >
                  Upgrade to Premium
                </AnimatedButton>
              </Box>
            )}
            {user?.status === 'premium' && subscriptionDaysRemaining !== null && !subscriptionExpired && (
              <Box sx={{ textAlign: 'center' }}>
                <Box sx={{ position: 'relative', display: 'inline-flex', mb: 2 }}>
                  <CircularProgress
                    variant="determinate"
                    value={subscriptionProgress}
                    size={80}
                    thickness={5}
                    sx={{ color: 'white' }}
                  />
                  <Box
                    sx={{
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      position: 'absolute',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Typography
                      variant="caption"
                      component="div"
                      sx={{ color: 'white', fontWeight: '600', fontSize: '1rem' }}
                    >
                      {`${subscriptionDaysRemaining} day${subscriptionDaysRemaining !== 1 ? 's' : ''} left`}
                    </Typography>
                  </Box>
                </Box>
                <AnimatedButton
                  variant="contained"
                  onClick={() => navigate('/pricing')}
                  sx={{
                    background: colors.accent,
                    color: 'white',
                    fontSize: '0.9rem',
                    padding: '8px 16px',
                  }}
                >
                  Renew Subscription
                </AnimatedButton>
              </Box>
            )}
          </ModernCard>
        )}

        {isPremiumUser && recommendedTopics.length > 0 && !openTrialExpiredModal && !openSubscriptionExpiredModal && (
          <>
            <Typography variant="h4" sx={{ mb: 4, fontWeight: '700', color: colors.secondary }}>
              Recommended for You
            </Typography>
            <Grid container spacing={3} sx={{ mb: 5 }}>
              {recommendedTopics.map((topic) => {
                const { viewedCount, totalResources, percentage } = getTopicProgress(topic.id);
                const isPremiumTopic = topic.accessStatus === 'premium';
                return (
                  <Grid key={topic.id} size={{ xs: 12, md: 4 }}>
                    <ModernCard>
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: '600', color: colors.secondary, display: 'flex', alignItems: 'center' }}
                      >
                        {isPremiumTopic && <StarIcon sx={{ color: starColor, mr: 1 }} />}
                        {topic.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 1 }}>
                        {topic.description}
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 2.5, color: colors.primary }}>
                        Progress: {viewedCount}/{totalResources} ({percentage}%)
                      </Typography>
                      <Link to={`/viewtopic/${topic.id}`} style={{ textDecoration: 'none' }}>
                        <AnimatedButton variant="outlined" color="primary" endIcon={<ArrowForwardIcon />}>
                          View Topic
                        </AnimatedButton>
                      </Link>
                    </ModernCard>
                  </Grid>
                );
              })}
            </Grid>
            <Divider sx={{ my: 4, borderColor: 'rgba(0, 0, 0, 0.1)' }} />
          </>
        )}

        {!openTrialExpiredModal && !openSubscriptionExpiredModal && (
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            sx={{ mb: 5, justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: { xs: 1, sm: 2 } }}
          >
            {[
              { label: 'All Topics', icon: <MenuBookIcon /> },
              { label: 'School Level', icon: <LocationCityIcon /> },
              { label: 'All Subjects', icon: <CastForEducationIcon /> },
              { label: 'Past Papers', icon: <LibraryBooksIcon /> },
              { label: 'Revision Hub', icon: <AutoStoriesIcon /> },
            ].map(({ label, icon }) => (
              <ChipStyled
                key={label}
                label={label}
                icon={icon}
                color="primary"
                variant={selectedChip === label ? 'filled' : 'outlined'}
                onClick={() => handleChipClick(label)}
                sx={{
                  bgcolor: selectedChip === label ? colors.primary : 'transparent',
                  color: selectedChip === label ? 'white' : colors.secondary,
                  minWidth: { xs: '150px', sm: 'auto' },
                  fontSize: { xs: '0.85rem', sm: '0.9rem' },
                  padding: { xs: '6px 12px', sm: '8px 16px' },
                }}
              />
            ))}
          </Stack>
        )}

        {selectedChip === 'All Topics' && !openTrialExpiredModal && !openSubscriptionExpiredModal && (
          <Box sx={{ mb: 4, maxWidth: '600px', mx: 'auto' }}>
            <TextField
              fullWidth
              label="Search Topics"
              value={searchQuery}
              onChange={handleSearchChange}
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                  backgroundColor: 'white',
                  '& fieldset': { borderColor: colors.primary },
                  '&:hover fieldset': { borderColor: colors.accent },
                  '&.Mui-focused fieldset': { borderColor: colors.accent },
                },
                '& .MuiInputLabel-root': {
                  color: colors.secondary,
                  '&.Mui-focused': { color: colors.accent },
                },
              }}
              placeholder="Enter topic name or description..."
            />
          </Box>
        )}

        {selectedChip === 'Past Papers' && selectedPastPaperCategory && !openTrialExpiredModal && !openSubscriptionExpiredModal && (
          <Box sx={{ mb: 4, maxWidth: '600px', mx: 'auto' }}>
            <TextField
              fullWidth
              label="Search Past Papers"
              value={searchQuery}
              onChange={handleSearchChange}
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                  backgroundColor: 'white',
                  '& fieldset': { borderColor: colors.primary },
                  '&:hover fieldset': { borderColor: colors.accent },
                  '&.Mui-focused fieldset': { borderColor: colors.accent },
                },
                '& .MuiInputLabel-root': {
                  color: colors.secondary,
                  '&.Mui-focused': { color: colors.accent },
                },
              }}
              placeholder="Enter past paper title or description..."
            />
          </Box>
        )}

        {selectedChip === 'Revision Hub' && selectedRevisionPaperCategory && !openTrialExpiredModal && !openSubscriptionExpiredModal && (
          <Box sx={{ mb: 4, maxWidth: '600px', mx: 'auto' }}>
            <TextField
              fullWidth
              label="Search Revision Papers"
              value={searchQuery}
              onChange={handleSearchChange}
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                  backgroundColor: 'white',
                  '& fieldset': { borderColor: colors.primary },
                  '&:hover fieldset': { borderColor: colors.accent },
                  '&.Mui-focused fieldset': { borderColor: colors.accent },
                },
                '& .MuiInputLabel-root': {
                  color: colors.secondary,
                  '&.Mui-focused': { color: colors.accent },
                },
              }}
              placeholder="Enter revision paper title or description..."
            />
          </Box>
        )}

        <Fade in={true} timeout={400}>
          <Box>
            {selectedChip === 'School Level' && !selectedSchoolLevel && !openTrialExpiredModal && !openSubscriptionExpiredModal && (
              <>
                <Typography variant="h4" sx={{ mb: 4, fontWeight: '700', color: colors.secondary }}>
                  School Levels
                </Typography>
                <Grid container spacing={3}>
                  {schoolLevels.length > 0 ? (
                    schoolLevels.map((schoolLevel) => {
                      const { viewedCount, totalResources, percentage } = getSchoolLevelProgress(schoolLevel.id);
                      return (
                        <Grid key={schoolLevel.id} size={{ xs: 12, md: 6 }}>
                          <ModernCard>
                            <Typography variant="h6" sx={{ fontWeight: '600', color: colors.secondary }}>
                              {iconMap[schoolLevel.icon]} {schoolLevel.name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 1 }}>
                              {schoolLevel.description}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 2.5, color: colors.primary }}>
                              Progress: {viewedCount}/{totalResources} ({percentage}%)
                            </Typography>
                            <AnimatedButton
                              variant="outlined"
                              color="primary"
                              onClick={() => handleViewSchoolLevelTopics(schoolLevel.id)}
                              endIcon={<ArrowForwardIcon />}
                            >
                              View Topics
                            </AnimatedButton>
                          </ModernCard>
                        </Grid>
                      );
                    })
                  ) : (
                    <Typography sx={{ textAlign: 'center', width: '100%', color: colors.secondary }}>
                      No school levels available.
                    </Typography>
                  )}
                </Grid>
              </>
            )}

            {selectedChip === 'School Level' && selectedSchoolLevel && !openTrialExpiredModal && !openSubscriptionExpiredModal && (
              <>
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 4 }}>
                  <Typography variant="h4" sx={{ fontWeight: '700', color: colors.secondary }}>
                    Topics for {schoolLevels.find((sl) => sl.id === selectedSchoolLevel)?.name}
                  </Typography>
                  <AnimatedButton variant="outlined" color="primary" onClick={() => setSelectedSchoolLevel(null)}>
                    Back
                  </AnimatedButton>
                </Stack>
                <Grid container spacing={3}>
                  {topics.length > 0 ? (
                    topics.map((topic) => {
                      const { viewedCount, totalResources, percentage } = getTopicProgress(topic.id);
                      const isPremiumTopic = topic.accessStatus === 'premium';
                      return (
                        <Grid key={topic.id} size={{ xs: 12, md: 6 }}>
                          <ModernCard>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: '600', color: colors.secondary, display: 'flex', alignItems: 'center' }}
                            >
                              {isPremiumTopic && <StarIcon sx={{ color: starColor, mr: 1 }} />}
                              {topic.name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 1 }}>
                              {topic.description}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 2.5, color: colors.primary }}>
                              Progress: {viewedCount}/{totalResources} ({percentage}%)
                            </Typography>
                            {isPremiumTopic && !isPremiumUser ? (
                              <AnimatedButton
                                variant="outlined"
                                color="primary"
                                endIcon={<ArrowForwardIcon />}
                                onClick={handlePremiumModalOpen}
                              >
                                View Topic
                              </AnimatedButton>
                            ) : (
                              <Link to={`/viewtopic/${topic.id}`} style={{ textDecoration: 'none' }}>
                                <AnimatedButton variant="outlined" color="primary" endIcon={<ArrowForwardIcon />}>
                                  View Topic
                                </AnimatedButton>
                              </Link>
                            )}
                          </ModernCard>
                        </Grid>
                      );
                    })
                  ) : (
                    <Typography sx={{ textAlign: 'center', width: '100%', color: colors.secondary }}>
                      No topics available for this school level.
                    </Typography>
                  )}
                </Grid>
              </>
            )}

            {selectedChip === 'All Subjects' && !selectedSubject && !openTrialExpiredModal && !openSubscriptionExpiredModal && (
              <>
                <Typography variant="h4" sx={{ mb: 4, fontWeight: '700', color: colors.secondary }}>
                  Subjects
                </Typography>
                <Grid container spacing={3}>
                  {subjects.length > 0 ? (
                    subjects.map((subject) => {
                      const { viewedCount, totalResources, percentage } = getSubjectProgress(subject.id);
                      return (
                        <Grid key={subject.id} size={{ xs: 12, md: 6 }}>
                          <ModernCard>
                            <Typography variant="h6" sx={{ fontWeight: '600', color: colors.secondary }}>
                              {iconMap[subject.icon]} {subject.name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 1 }}>
                              {subject.description}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 2.5, color: colors.primary }}>
                              Progress: {viewedCount}/{totalResources} ({percentage}%)
                            </Typography>
                            <AnimatedButton
                              variant="outlined"
                              color="primary"
                              onClick={() => handleViewSubject(subject.id)}
                              endIcon={<ArrowForwardIcon />}
                            >
                              View Topics
                            </AnimatedButton>
                          </ModernCard>
                        </Grid>
                      );
                    })
                  ) : (
                    <Typography sx={{ textAlign: 'center', width: '100%', color: colors.secondary }}>
                      No subjects available.
                    </Typography>
                  )}
                </Grid>
              </>
            )}

            {selectedChip === 'All Subjects' && selectedSubject && !openTrialExpiredModal && !openSubscriptionExpiredModal && (
              <>
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 4 }}>
                  <Typography variant="h4" sx={{ fontWeight: '700', color: colors.secondary }}>
                    Topics for {subjects.find((s) => s.id === selectedSubject)?.name}
                  </Typography>
                  <AnimatedButton variant="outlined" color="primary" onClick={() => setSelectedSubject(null)}>
                    Back
                  </AnimatedButton>
                </Stack>
                <Grid container spacing={3}>
                  {topics.length > 0 ? (
                    topics.map((topic) => {
                      const { viewedCount, totalResources, percentage } = getTopicProgress(topic.id);
                      const isPremiumTopic = topic.accessStatus === 'premium';
                      return (
                        <Grid key={topic.id} size={{ xs: 12, md: 6 }}>
                          <ModernCard>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: '600', color: colors.secondary, display: 'flex', alignItems: 'center' }}
                            >
                              {isPremiumTopic && <StarIcon sx={{ color: starColor, mr: 1 }} />}
                              {topic.name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 1 }}>
                              {topic.description}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 2.5, color: colors.primary }}>
                              Progress: {viewedCount}/{totalResources} ({percentage}%)
                            </Typography>
                            {isPremiumTopic && !isPremiumUser ? (
                              <AnimatedButton
                                variant="outlined"
                                color="primary"
                                endIcon={<ArrowForwardIcon />}
                                onClick={handlePremiumModalOpen}
                              >
                                View Topic
                              </AnimatedButton>
                            ) : (
                              <Link to={`/viewtopic/${topic.id}`} style={{ textDecoration: 'none' }}>
                                <AnimatedButton variant="outlined" color="primary" endIcon={<ArrowForwardIcon />}>
                                  View Topic
                                </AnimatedButton>
                              </Link>
                            )}
                          </ModernCard>
                        </Grid>
                      );
                    })
                  ) : (
                    <Typography sx={{ textAlign: 'center', width: '100%', color: colors.secondary }}>
                      No topics available for this subject.
                    </Typography>
                  )}
                </Grid>
              </>
            )}

            {selectedChip === 'All Topics' && !openTrialExpiredModal && !openSubscriptionExpiredModal && (
              <>
                <Typography variant="h4" sx={{ mb: 4, fontWeight: '700', color: colors.secondary }}>
                  All Topics
                </Typography>
                <Grid container spacing={3}>
                  {topics.length > 0 ? (
                    topics.map((topic) => {
                      const { viewedCount, totalResources, percentage } = getTopicProgress(topic.id);
                      const isPremiumTopic = topic.accessStatus === 'premium';
                      return (
                        <Grid key={topic.id} size={{ xs: 12, md: 6 }}>
                          <ModernCard>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: '600', color: colors.secondary, display: 'flex', alignItems: 'center' }}
                            >
                              {isPremiumTopic && <StarIcon sx={{ color: starColor, mr: 1 }} />}
                              {topic.name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 1 }}>
                              {topic.description}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 2.5, color: colors.primary }}>
                              Progress: {viewedCount}/{totalResources} ({percentage}%)
                            </Typography>
                            {isPremiumTopic && !isPremiumUser ? (
                              <AnimatedButton
                                variant="outlined"
                                color="primary"
                                endIcon={<ArrowForwardIcon />}
                                onClick={handlePremiumModalOpen}
                              >
                                View Topic
                              </AnimatedButton>
                            ) : (
                              <Link to={`/viewtopic/${topic.id}`} style={{ textDecoration: 'none' }}>
                                <AnimatedButton variant="outlined" color="primary" endIcon={<ArrowForwardIcon />}>
                                  View Topic
                                </AnimatedButton>
                              </Link>
                            )}
                          </ModernCard>
                        </Grid>
                      );
                    })
                  ) : (
                    <Typography sx={{ textAlign: 'center', width: '100%', color: colors.secondary }}>
                      {searchQuery ? 'No topics match your search.' : 'No topics available.'}
                    </Typography>
                  )}
                </Grid>
              </>
            )}

            {selectedChip === 'Past Papers' && !selectedPastPaperCategory && !openTrialExpiredModal && !openSubscriptionExpiredModal && (
              <>
                <Typography variant="h4" sx={{ mb: 4, fontWeight: '700', color: colors.secondary }}>
                  Past Papers
                </Typography>
                <Grid container spacing={3}>
                  {getPastPaperCategories().length > 0 ? (
                    getPastPaperCategories().map((category) => (
                      <Grid key={category.name} size={{ xs: 12, md: 6 }}>
                        <ModernCard>
                          <Typography
                            variant="h6"
                            sx={{ fontWeight: '600', color: colors.secondary, display: 'flex', alignItems: 'center' }}
                          >
                            <FolderIcon sx={{ color: colors.primary, mr: 1 }} />
                            {category.name}
                          </Typography>
                          <Typography variant="body2" sx={{ mb: 2.5, color: colors.primary }}>
                            {category.count} past paper{category.count !== 1 ? 's' : ''}
                          </Typography>
                          <AnimatedButton
                            variant="outlined"
                            color="primary"
                            onClick={() => handleViewPastPaperCategory(category.name)}
                            endIcon={<ArrowForwardIcon />}
                          >
                            View Papers
                          </AnimatedButton>
                        </ModernCard>
                      </Grid>
                    ))
                  ) : (
                    <Typography sx={{ textAlign: 'center', width: '100%', color: colors.secondary }}>
                      No past papers available.
                    </Typography>
                  )}
                </Grid>
              </>
            )}

            {selectedChip === 'Past Papers' && selectedPastPaperCategory && !openTrialExpiredModal && !openSubscriptionExpiredModal && (
              <>
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 4 }}>
                  <Typography variant="h4" sx={{ fontWeight: '700', color: colors.secondary }}>
                    Past Papers - {selectedPastPaperCategory}
                  </Typography>
                  <AnimatedButton
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setSelectedPastPaperCategory(null);
                      setSearchQuery('');
                    }}
                  >
                    Back
                  </AnimatedButton>
                </Stack>
                <Grid container spacing={3}>
                  {pastPapers.length > 0 ? (
                    pastPapers.map((paper) => {
                      const isPremiumPaper = paper.accessStatus === 'premium';
                      return (
                        <Grid key={paper.id} size={{ xs: 12, md: 6 }}>
                          <ModernCard>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: '600', color: colors.secondary, display: 'flex', alignItems: 'center' }}
                            >
                              {isPremiumPaper && <StarIcon sx={{ color: starColor, mr: 1 }} />}
                              {paper.title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 1 }}>
                              {paper.description}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 1, color: colors.primary }}>
                              Year: {paper.year}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 1, color: colors.primary }}>
                              Subject: {paper.subject}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 2.5, color: colors.primary }}>
                              School Level: {paper.schoolLevel}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                mb: 2.5,
                                color: isPremiumPaper ? colors.accent : colors.primary,
                                fontWeight: '600',
                              }}
                            >
                              Access: {paper.accessStatus.charAt(0).toUpperCase() + paper.accessStatus.slice(1)}
                            </Typography>
                            <Stack direction="row" spacing={2}>
                              {isPremiumPaper && !isPremiumUser ? (
                                <AnimatedButton
                                  variant="outlined"
                                  color="primary"
                                  endIcon={<ArrowForwardIcon />}
                                  onClick={handlePremiumModalOpen}
                                >
                                  View Past Paper
                                </AnimatedButton>
                              ) : (
                                <AnimatedButton
                                  variant="outlined"
                                  color="primary"
                                  endIcon={<ArrowForwardIcon />}
                                  onClick={() => handleViewPastPaper(paper)}
                                >
                                  View Past Paper
                                </AnimatedButton>
                              )}
                              <AnimatedButton
                                variant="outlined"
                                color="primary"
                                endIcon={<ArrowForwardIcon />}
                                onClick={() => handleViewPastPaperSolution(paper)}
                                disabled={!isPremiumUser}
                                sx={{
                                  opacity: !isPremiumUser ? 0.5 : 1,
                                  cursor: !isPremiumUser ? 'not-allowed' : 'pointer',
                                }}
                              >
                                View Past Paper Solution
                              </AnimatedButton>
                            </Stack>
                          </ModernCard>
                        </Grid>
                      );
                    })
                  ) : (
                    <Typography sx={{ textAlign: 'center', width: '100%', color: colors.secondary }}>
                      {searchQuery ? 'No past papers match your search.' : 'No past papers available.'}
                    </Typography>
                  )}
                </Grid>
              </>
            )}

            {selectedChip === 'Revision Hub' && !selectedRevisionPaperCategory && !openTrialExpiredModal && !openSubscriptionExpiredModal && (
              <>
                <Typography variant="h4" sx={{ mb: 4, fontWeight: '700', color: colors.secondary }}>
                  Revision Hub
                </Typography>
                <Grid container spacing={3}>
                  {getRevisionPaperCategories().length > 0 ? (
                    getRevisionPaperCategories().map((category) => (
                      <Grid key={category.name} size={{ xs: 12, md: 6 }}>
                        <ModernCard>
                          <Typography
                            variant="h6"
                            sx={{ fontWeight: '600', color: colors.secondary, display: 'flex', alignItems: 'center' }}
                          >
                            <FolderIcon sx={{ color: colors.primary, mr: 1 }} />
                            {category.name}
                          </Typography>
                          <Typography variant="body2" sx={{ mb: 2.5, color: colors.primary }}>
                            {category.count} revision paper{category.count !== 1 ? 's' : ''}
                          </Typography>
                          <AnimatedButton
                            variant="outlined"
                            color="primary"
                            onClick={() => handleViewRevisionPaperCategory(category.name)}
                            endIcon={<ArrowForwardIcon />}
                          >
                            View Papers
                          </AnimatedButton>
                        </ModernCard>
                      </Grid>
                    ))
                  ) : (
                    <Typography sx={{ textAlign: 'center', width: '100%', color: colors.secondary }}>
                      No revision papers available.
                    </Typography>
                  )}
                </Grid>
              </>
            )}

            {selectedChip === 'Revision Hub' && selectedRevisionPaperCategory && !openTrialExpiredModal && !openSubscriptionExpiredModal && (
              <>
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 4 }}>
                  <Typography variant="h4" sx={{ fontWeight: '700', color: colors.secondary }}>
                    Revision Hub - {selectedRevisionPaperCategory}
                  </Typography>
                  <AnimatedButton
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setSelectedRevisionPaperCategory(null);
                      setSearchQuery('');
                    }}
                  >
                    Back
                  </AnimatedButton>
                </Stack>
                <Grid container spacing={3}>
                  {revisionPapers.length > 0 ? (
                    revisionPapers.map((paper) => {
                      const isPremiumPaper = paper.accessStatus === 'premium';
                      return (
                        <Grid key={paper.id} size={{ xs: 12, md: 6 }}>
                          <ModernCard>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: '600', color: colors.secondary, display: 'flex', alignItems: 'center' }}
                            >
                              {isPremiumPaper && <StarIcon sx={{ color: starColor, mr: 1 }} />}
                              {paper.title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 1 }}>
                              {paper.description}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 1, color: colors.primary }}>
                              Year: {paper.year}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 1, color: colors.primary }}>
                              Subject: {paper.subject}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 2.5, color: colors.primary }}>
                              School Level: {paper.schoolLevel}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                mb: 2.5,
                                color: isPremiumPaper ? colors.accent : colors.primary,
                                fontWeight: '600',
                              }}
                            >
                              Access: {paper.accessStatus.charAt(0).toUpperCase() + paper.accessStatus.slice(1)}
                            </Typography>
                            <Stack direction="row" spacing={2}>
                              {isPremiumPaper && !isPremiumUser ? (
                                <AnimatedButton
                                  variant="outlined"
                                  color="primary"
                                  endIcon={<ArrowForwardIcon />}
                                  onClick={handlePremiumModalOpen}
                                >
                                  Start Quiz
                                </AnimatedButton>
                              ) : (
                                <AnimatedButton
                                  variant="outlined"
                                  color="primary"
                                  endIcon={<ArrowForwardIcon />}
                                  onClick={() => handleStartRevisionQuiz(paper)}
                                >
                                  Start Quiz
                                </AnimatedButton>
                              )}
                              <AnimatedButton
                                variant="outlined"
                                color="primary"
                                endIcon={<ArrowForwardIcon />}
                                onClick={() => handleViewRevisionLeaderboard(paper)}
                                disabled={!isPremiumUser}
                                sx={{
                                  opacity: !isPremiumUser ? 0.5 : 1,
                                  cursor: !isPremiumUser ? 'not-allowed' : 'pointer',
                                }}
                              >
                                View Leaderboard
                              </AnimatedButton>
                            </Stack>
                          </ModernCard>
                        </Grid>
                      );
                    })
                  ) : (
                    <Typography sx={{ textAlign: 'center', width: '100%', color: colors.secondary }}>
                      {searchQuery ? 'No revision papers match your search.' : 'No revision papers available.'}
                    </Typography>
                  )}
                </Grid>
              </>
            )}
          </Box>
        </Fade>
      </Container>
    </div>
  );
};

export default Dashboard;